export function setTimeoutIfPossible(handler, timeout) {
    // eslint-disable-next-line
    for(var _len = arguments.length, argumentsArray = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        argumentsArray[_key - 2] = arguments[_key];
    }
    // eslint-disable-next-line @faire/ssr-no-restricted-globals
    if ("object" === "undefined") {
        throw new Error("Next.js doesn't allow setTimeout");
    } else {
        // eslint-disable-next-line @faire/ssr-no-restricted-globals
        return window.setTimeout(handler, timeout, argumentsArray);
    }
}
